<template>
	<tr @click="openTaskDialog" class="task-container">
		<td>
			<div class="d-flex align-center">
				<v-checkbox
					@click.stop
					color="accent"
					class="pa-0 ma-0"
					hide-details
					dense
					v-model="checked"
					@change="changeTaskCheck(task.id)"
					:ripple="false"
				>
				</v-checkbox>
				<span
					:class="task.status === 'finished' ? 'completed' : null"
					class="task-name"
				>
					{{ task.title }}
				</span>
				<v-icon v-if="task.attachments.length" class="ml-2">
					$attachment
				</v-icon>

				<v-tooltip
					top
					v-if="
						task.creator_user_id &&
						task.creator_user_id !== $store.state.auth.user.id
					"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-icon
							v-bind="attrs"
							v-on="on"
							class="ml-1"
							>$received-task</v-icon>
					</template>
					<span>
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.task.tooltip.commissionedFrom"
							)
						}}
						{{ task.creator_user.name }}
					</span>
				</v-tooltip>

				<v-tooltip
					top
					v-if="
						task.creator_user_id &&
						task.creator_user_id === $store.state.auth.user.id
					"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" icon v-bind="attrs" v-on="on">
							<v-icon>$commissioned-task</v-icon>
						</v-btn>
					</template>
					<span>
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.task.tooltip.commissionedTo"
							)
						}}
						{{ task.task_user.name }}
					</span>
				</v-tooltip>
			</div>
		</td>
		<td>
			<div class="deadline align-center" :class="deadlineLabel.class">
				<v-icon>${{ deadlineLabel.icon }}</v-icon>
				<span class="pl-1">
					{{ deadlineLabel.name }}
				</span>
			</div>
		</td>
		<td>
			<div>
				<priority :className="priorityObj.class">
					{{ priorityObj.name }}
				</priority>
			</div>
		</td>
		<td>
			<span class="type">{{ typeOfLabel }}</span>
		</td>
	</tr>
</template>

<script>
import Priority from "@/components/tasks/Priority";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
	components: {
		Priority,
	},
	props: {
		task: {
			type: Object,
			required: true,
		},
		isTaskChecked: {
			type: Boolean,
		},
	},
	data() {
		return {
			creatorName: "",
			recivedName: "",
			checked: this.isTaskChecked,
		};
	},
	computed: {
		...mapGetters({ user: "auth/user" }),
		priorityObj() {
			if (this.task.priority === "high") {
				return { class: "high-priority", name: "Wysoki" };
			} else if (this.task.priority === "medium") {
				return { class: "medium-priority", name: "Średni" };
			} else if (this.task.priority === "low") {
				return { class: "low-priority", name: "Niski" };
			} else {
				return { class: "none-priority", name: "" };
			}
		},

		deadlineLabel() {
			if (this.task.deadline) {
				const deadline = this.$moment(
					this.task.deadline.split("Z")[0]
				).format("YYYY-MM-DD");

				if (deadline === this.$moment().format("YYYY-MM-DD")) {
					return {
						class: "today",
						name: "Na dziś",
						icon: "task-deadline-today",
					};
				} else if (this.$moment(deadline).isBefore()) {
					return {
						class: "today",
						name: this.$moment(deadline)
							.format("DD,MMMM")
							.replace(",", " "),
						icon: "task-deadline-today",
					};
				} else if (
					deadline ===
					this.$moment().add(1, "days").format("YYYY-MM-DD")
				) {
					return {
						class: "tomorrow",
						name: "Na jutro",
						icon: "task-deadline-tomorrow",
					};
				} else {
					return {
						class: "date",
						name: this.$moment(deadline)
							.format("DD,MMMM")
							.replace(",", " "),
						icon: "task-deadline-date",
					};
				}
			} else {
				return { class: "without-deadline", icon: "" };
			}
		},

		typeOfLabel() {
			if (
				this.task.creator_user_id === this.task.user_id ||
				!this.task.creator_user_id
			) {
				return "Moje";
			} else if (this.task.user_id === this.user.id) {
				return "Otrzymane";
			} else if (this.task.user_id !== this.user.id) {
				return "Zlecone";
			} else {
				return "";
			}
		},
	},

	methods: {
		openTaskDialog(event) {
			this.$emit("openTaskDialog", event.target.value);
		},

		async getUserName(id) {
			let name;
			await axios
				.get(`users/profile/${id}`)
				.then((response) => {
					name = response.data.data.name;
				})
				.catch((e) => {
					console.log("GET USER NAME ERROR", e);
				});
			return name;
		},

		changeTaskCheck(id) {
			this.$emit("changeTaskCheck", { id, checked: this.checked });
		},
	},
};
</script>

<style lang="scss" scoped>
.task-container {
	max-width: none;
	cursor: pointer;
}
.type {
	background-color: var(--v-grey-lighten4);
	color: var(--v-grey-darken3);
}
.deadline {
	display: flex;
	width: max-content;
	color: white;
	background-color: $color-blue;
	span {
		line-height: 16px;
		font-size: 12px;
	}
	&.without-deadline {
		display: none;
	}
	&.today {
		background-color: $color-red;
	}
	&.tomorrow {
		background-color: $color-orange;
	}
}
.priority,
.type,
.deadline {
	font-size: 12px;
	font-weight: 600;
}
.deadline,
.type {
	padding: 4px 8px;
	border-radius: 5000px;
}
</style>

<style lang="scss">
.task-container label.v-label.theme--light {
	color: var(--v-grey-darken1);
}

.task-container
	.v-input.pa-0.ma-0.v-input--is-label-active.v-input--is-dirty.theme--light.v-input--selection-controls.v-input--checkbox.accent--text
	label.v-label.theme--light {
	text-decoration: none;
}

.task-name {
	font-size: 14px;
	font-weight: 500;
}

.completed {
	text-decoration: line-through;
}

.task-name {
	font-size: 14px;
	font-weight: 500;
}
</style>
